import { IosFetchBridgeProvider } from '@chewy/ios-fetch-bridge/react';
import { createContext, ReactNode, useContext } from 'react';

import { useIosFetchBridgeToggle } from '@/hooks/feature-flag-hooks/useIosFetchBridgeToggle';

const LoyaltyIosFetchBridgeContext = createContext(false);

interface Props {
  children: ReactNode;
  isNativeMobileApp: boolean;
}

export const useLoyaltyIosFetchBridge = () => useContext(LoyaltyIosFetchBridgeContext);

export const LoyaltyIosFetchBridgeProvider = ({ children, isNativeMobileApp }: Props) => {
  const isIosFetchBridgeToggleEnabled = useIosFetchBridgeToggle();
  const isIosFetchBridgeEnabled = isNativeMobileApp && isIosFetchBridgeToggleEnabled;

  return (
    <LoyaltyIosFetchBridgeContext.Provider value={isIosFetchBridgeEnabled}>
      <IosFetchBridgeProvider enabled={isIosFetchBridgeEnabled}>{children}</IosFetchBridgeProvider>
    </LoyaltyIosFetchBridgeContext.Provider>
  );
};
